var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useState } from "react";
import clsx from "clsx";
import SpinnerIcon from "@assets/icon-spinner.svg";
import { Tooltip } from "@components";
import styles from "./Button.module.scss";
export function Button(_a) {
    var { type = "button", variant = "contained", color = "primary", disabled = false, isLoading, className, children, onClick, externalRef, title, leftIcon, theme = "light" } = _a, props = __rest(_a, ["type", "variant", "color", "disabled", "isLoading", "className", "children", "onClick", "externalRef", "title", "leftIcon", "theme"]);
    const fallbackRef = useRef(null);
    const [isHovered, setIsHovered] = useState(false);
    /* eslint-disable react/button-has-type */
    return (React.createElement(React.Fragment, null,
        React.createElement("button", Object.assign({ onPointerEnter: () => {
                setIsHovered(true);
            }, onPointerLeave: () => {
                setIsHovered(false);
            }, type: type, className: clsx(styles.button, styles[color], styles[variant], styles[theme], (leftIcon || isLoading) && styles.withLeftIcon, className), onClick: onClick, disabled: disabled, ref: externalRef || fallbackRef }, props),
            isLoading ? React.createElement(SpinnerIcon, { className: styles.loaderIcon }) : leftIcon,
            children),
        !!title && isHovered && React.createElement(Tooltip, { anchorRef: externalRef || fallbackRef }, title)));
}
